import { ModalDialog } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  pendingCount: number;
  dueDateLabel: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const RemindModalPresentation: React.FC<Props> = ({
  pendingCount,
  dueDateLabel,
  onClose,
  onConfirm,
}) => (
  <ModalDialog
    isOpen
    title='再送信内容の確認'
    onClose={onClose}
    onConfirm={onConfirm}
    description=''
    confirmText='送信'
  >
    <div className={styles.modalContent}>
      <div className={styles.modalRow}>
        <span className={styles.modalLabel}>従業員</span>
        <span className={styles.modalValue}>{pendingCount}人</span>
      </div>
      <div className={styles.modalRow}>
        <span className={styles.modalLabel}>回答期限</span>
        <span className={styles.modalValue}>{dueDateLabel}</span>
      </div>
    </div>
  </ModalDialog>
);
